import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {
  getMockCbRewardRecord,
  USE_MOCK_CB_REWARD_RECORD,
} from './mockdata'

export const homepage = createAsyncThunk(
  '/live/vip/homepage',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<InitialStateType>>(
      '/live/vip/homepage',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

export enum CbTierStatusEnum {
  未达标 = 0,
  可领 = 1,
  已领 = 2,
}

export interface CbHomepageReward {
  icon: string
  name: string
  badge: string
}

export interface CbHomepageTier {
  level: number
  target_growth_value: number
  background_url: string
  status: CbTierStatusEnum
  user_percent: string
  rewards: CbHomepageReward[]
  button_text: string
}

export interface CbHomepageData {
  err_msg: string
  avatar: string
  level: number
  honor_icon: string
  growth_value: number
  growth_multiplier: number
  tiers: CbHomepageTier[]
}

export interface CbRewardRecordItem {
  icon: string
  name: string
  level: number
  claim_time: string
  scheme: string
}

export interface CbRewardRecordData {
  err_msg: string
  list: CbRewardRecordItem[]
  offset: number
  more: boolean
}

export const RECORD_PAGE_LIMIT = 20

export const cb_homepage = createAsyncThunk(
  'HalfScreenGift/live/hiya_socialize/cb_homepage',
  async (params: any, store: any) => {
    const resp = await http.post<HiyaRes<CbHomepageData>>(
      '/live/hiya_socialize/cb_homepage',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const cb_claim = createAsyncThunk(
  'HalfScreenGift/live/hiya_socialize/cb_claim',
  async (params: any, store: any) => {
    const resp = await http.post<HiyaRes<CbHomepageData>>(
      '/live/hiya_socialize/cb_claim',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const cb_reward_record = createAsyncThunk(
  'HalfScreenGift/live/hiya_socialize/cb_reward_record',
  async (
    params: {
      offset: number
      limit: number
    },
    store: any
  ) => {
    if (USE_MOCK_CB_REWARD_RECORD) {
      return getMockCbRewardRecord(params.offset, params.limit)
    }
    const resp = await http.post<HiyaRes<CbRewardRecordData>>(
      '/live/hiya_socialize/cb_reward_record',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export enum TypeEnum {
  vip = 'vip',
  svip = 'svip',
}

export interface InitialStateType {
  user_info?: {
    avatar: string
    vip_type?: TypeEnum
  }
  toast?: string
  cbHome?: CbHomepageData
  record?: {
    loading: boolean
    inited: boolean
    list: CbRewardRecordItem[]
    offset: number
    more: boolean
  }
}

const initialState: InitialStateType = {
  record: {
    loading: false,
    inited: false,
    list: [],
    offset: 0,
    more: false,
  },
}

export const VipSlice = createSlice({
  name: 'HalfScreenGift',
  initialState,
  reducers: {
    clearRecord: (state) => {
      Object.assign(state.record, {
        loading: false,
        inited: false,
        list: [],
        offset: 0,
        more: false,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      const {user_info} = action.payload
      Object.assign(state, {
        ...action.payload,
        user_info: {
          ...user_info,
          vip_type: user_info?.vip_type || 'svip',
        },
      })
    })
    builder.addCase(cb_homepage.fulfilled, (state, action) => {
      Object.assign(state, {
        cbHome: action.payload,
      })
    })
    builder.addCase(cb_reward_record.pending, (state) => {
      Object.assign(state.record, {
        loading: true,
      })
    })
    builder.addCase(cb_reward_record.fulfilled, (state, action) => {
      const reqOffset = action.meta.arg.offset
      const payload = action.payload
      const list =
        reqOffset === 0
          ? payload.list || []
          : (state.record?.list || []).concat(payload.list || [])
      Object.assign(state.record, {
        loading: false,
        inited: true,
        list,
        offset: payload.offset,
        more: list.length === 0 ? false : !!payload.more,
      })
    })
    builder.addCase(cb_reward_record.rejected, (state) => {
      Object.assign(state.record, {
        loading: false,
        inited: true,
      })
    })
  },
})
export default VipSlice.reducer
export const HalfScreenGiftActions = VipSlice.actions

export const useVipState = () => {
  return useSelector((state) => state.HalfScreenGift)
}
